import { useState, useMemo } from "react";

import { useFavouriteItemsQuery } from "../../api";
import type {
  IFavouritesProviderContextValue,
  IFavouritesProviderContextState,
  IFavouritesProviderContextActions,
} from "./FavouritesProvider.types";

export function useFavouritesState(): IFavouritesProviderContextValue {
  const { data: favouriteItems = [], isLoading: isFavouriteItemsLoading } = useFavouriteItemsQuery();

  const [selectedFavouriteItemId, setSelectedFavouriteItemId] = useState<number | undefined>(undefined);

  const selectedFavouriteItem = useMemo(
    () => favouriteItems.find((item) => item.id === selectedFavouriteItemId),
    [favouriteItems, selectedFavouriteItemId]
  );

  const state = useMemo<IFavouritesProviderContextState>(
    () => ({
      selectedFavouriteItemId,
      selectedFavouriteItem,
      favouriteItems,
      isFavouriteItemsLoading,
    }),
    [favouriteItems, isFavouriteItemsLoading, selectedFavouriteItemId, selectedFavouriteItem]
  );
  const actions = useMemo<IFavouritesProviderContextActions>(
    () => ({
      setSelectedFavouriteItemId,
    }),
    [setSelectedFavouriteItemId]
  );
 
  const value = useMemo(() => ({ state, actions }), [actions, state]);

  return value;
}
